import React, { useState, useRef, useEffect, useCallback } from "react";
import EmptyPhoto from "../../../../images/EmptyPhoto.png";
import RightArrow from "../../../../images/arrow-right.svg";
import "./KYCInformation.scss";
import { getNotes, updateKYCInfo } from "../../../../util/API/KYC_legacy";
import CustomAlert from "../../../UI/CustomAlert/CustomAlert";
import { useSelector } from "react-redux";
import { Box, Autocomplete, Typography, TextField, Button, Dialog, DialogContent, DialogActions, Divider, Slider, Chip } from "@mui/material";
import { getOptionsForSelect } from "../../../../util/utilfunctions/utilFunctions";
import { stateData } from "../../../../constants/countrylist";
import PinPad from "../../../PinPad/PinPad";
import captureImage from "../../../../images/capture-image.svg";
import uploadImage from "../../../../images/upload-image.svg";
import { getKYCTypes } from "../../../../util/API/KYC_legacy";
import {IconButton} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { format, parseISO } from "date-fns";
import { Crop, RotateLeft, RotateRight, ZoomIn } from "@mui/icons-material"

function KYCInformation({ 
    selectedImage, 
    selectedUser, 
    docname, 
    hideDocNumber, 
    docNumber, 
    handleUpdate, 
    isReject, 
    handleIsReject, 
    onReject,
    kycData,
    status,
    docType,
    isEditing,
    setIsEditing,
    selfieChange,
    handleSelectedUser,
    setIsEyeSlash,
    setdoc1Visible,
    setdoc2Visible,
    setInfoVisible,
    setpassportVisible,
    refreshUserDetails,
    setKycAlert,
    setLoading
  }) {
  const [selectedBase64Image, setSelectedBase64Image] = useState(selectedImage?.image);
  const [idNum, setIdNum] = useState("");
  const [doctype, setDoctype] = useState(docname);
  const [alert, setAlert] = useState({
    showAlert: false, 
    severity: '',
    message: '',
    header: ''
  });
  const fileInputRef = useRef(null);
  const [comment, setComment] = useState("");
  const [extractedData, setExtractedData] = useState(null); // Store extracted data
  const [displayData, setDisplayData] = useState(null); // Store display data
  const [stateOptions, setStateOptions] = useState([{ key: "not-available", value: "not-available", label: "Not Available" }])
  const [displayStateOptions, setDisplayStateOptions] = useState([{ key: "not-available", value: "not-available", label: "Not Available" }])
  const [rejectionNote, setRejectionNote] = useState("");
  const [isHovered, setIsHovered] = useState(false); // State to manage hover effect
  const [isClicked, setIsClicked] = useState(false); // State to manage click behavior
  const [showPinPad, setShowPinPad] = useState(false);

  const [showCamera, setShowCamera] = useState(false);
  const [cameraTimeout, setCameraTimeout] = useState(null);
  const [countdown, setCountdown] = useState(120); 
  const [selectedKYCType, setSelectedKYCType] = useState(null);
  const [kycTypes, setKYCTypes] = useState([]);
  const [errors, setErrors] = useState({});
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const firstErrorRef = useRef(null);

  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [dragging, setDragging] = useState(false);
  const [previewDialogOpen, setPreviewDialogOpen] = useState(false);
  const [rotation, setRotation] = useState(0);
  const [zoom, setZoom] = useState(1);

  const [cropMode, setCropMode] = useState(false)
  const [cropArea, setCropArea] = useState({ x: 150, y: 150, width: 300, height: 300 })
  const [resizing, setResizing] = useState(null);

  const [tempOriginalImage, setTempOriginalImage] = useState(null);
  const [facingMode, setFacingMode] = useState("user");

  const dragStartRef = useRef({ x: 0, y: 0 });
  const imageRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    if (dragging) {
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
      window.addEventListener("touchmove", handleMouseMove);
      window.addEventListener("touchend", handleMouseUp);
    } else {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
      window.removeEventListener("touchmove", handleMouseMove);
      window.removeEventListener("touchend", handleMouseUp);
    }
  
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
      window.removeEventListener("touchmove", handleMouseMove);
      window.removeEventListener("touchend", handleMouseUp);
    };
  }, [dragging]);

  // const handleMouseDown = (e) => {
  //   e.preventDefault();
  //   setDragging(true);
  
  //   const clientX = e.clientX || e.touches?.[0].clientX;
  //   const clientY = e.clientY || e.touches?.[0].clientY;
  
  //   const containerRect = containerRef.current.getBoundingClientRect();
  
  //   dragStartRef.current = {
  //     x: clientX - containerRect.left - position.x,
  //     y: clientY - containerRect.top - position.y,
  //   };
  // };

  useEffect(() => {
    if (selectedImage) {
      setSelectedBase64Image(selectedImage?.image);
    }
  }, [selectedImage]);
  
  
  const handleMouseMove = (e) => {
    if (!dragging || !containerRef.current) return;
  
    const clientX = e.clientX || e.touches?.[0].clientX;
    const clientY = e.clientY || e.touches?.[0].clientY;
  
    const containerRect = containerRef.current.getBoundingClientRect();
  
    const x = clientX - containerRect.left - dragStartRef.current.x;
    const y = clientY - containerRect.top - dragStartRef.current.y;
  
    setPosition({ x, y });
  };
  
  const handleMouseUp = () => {
    setDragging(false);
  };

  useEffect(() => {
    const KYCTypes = async () => {
      try {
        const response = await getKYCTypes();
        console.log(response);
  
        const data = response.payload.body.record;

        const defaultTypes = [
          {
            key: "Passport",
            value: "Passport",
            label: "Passport"
          },
          {
            key: "Selfie",
            value: "Selfie",
            label: "Selfie"
          }
        ]
  
        const keyValueLabelArray = data.map((item) => {
          const key = item.domainattributes.domainatt;
          const value = item.domainattributes.attname; 
          const label = item.domainattributes.attname;
  
          return { key, value, label };
        });
  
        setKYCTypes([...defaultTypes, ...keyValueLabelArray]);
      } catch (error) {
        console.log(error);
      }
    };
  
    KYCTypes();
  }, []);

  useEffect(() => {
      setSelectedKYCType(kycTypes?.find((type) => type?.value === docname));
  }, [kycTypes, docname])


  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  let pin = sessionStorage.getItem("pin");
  const pinConfiguration = useSelector((state) => state.login.pinConfiguration);
  let agent = JSON.parse(sessionStorage.getItem("user")).payload?.body;

  const user = useSelector((state) => state.usersList.userID);


  useEffect(() => {
    const updateStateOptions = (fieldValue) => {
      console.log("i am here", fieldValue)
      if (fieldValue.value === "na") {
        return [{ key: "not-available", value: "not-available", label: "Not Available" }]
      }

      const findData = stateData.find((country) => country.iso3 === fieldValue)

      const states = findData?.states?.length === 0 ? [{ key: "not-available", value: "not-available", label: "Not Available" }] : findData?.states ;
      return states?.map((state) => ({
        key: state.state_code,
        value: state.state_code,
        label: state.name,
      }));
    };

    setStateOptions(extractedData?.country ? updateStateOptions(extractedData?.country) : [{ key: "not-available", value: "not-available", label: "Not Available" }]);
    setDisplayStateOptions(displayData?.country ? updateStateOptions(displayData?.country) : [{ key: "not-available", value: "not-available", label: "Not Available" }]);
  }, [extractedData, displayData]);

  const getStatus = (statusName) => {
    if (statusName == "Accepted") {
      return "2";
    } else if (statusName == "Pending") {
      return "1";
    } else {
      return "3";
    }
  };

  const handleFileSelect = (event) => {
    const file = event.target.files?.[0];
    if (file) {
        if (docname === "Selfie") {
            const currentTime = new Date();
            const fileTime = new Date(file.lastModified);
            const timeDifference = (currentTime - fileTime) / 60000;

            if (timeDifference > 2) {
                setAlert({
                    showAlert: true,
                    severity: "error",
                    message: "The selected image was captured more than 2 minutes ago. Please capture a new selfie.",
                    header: "Invalid Selfie",
                });
                setShowCamera(false);
                if (fileInputRef.current) {
                    fileInputRef.current.value = "";
                }
                return;
            }
        }

        const reader = new FileReader();
        reader.onload = (e) => {
            const base64Data = e.target?.result;

            // 1. Save the clean backup
            setTempOriginalImage(base64Data);

            // 2. Set display image
            setSelectedBase64Image(base64Data);

            // 3. Trigger Modal
            setPreviewDialogOpen(true);

            // 4. Reset Editor States
            setZoom(1);
            setRotation(0);
            setPosition({ x: 0, y: 0 });
            
            // Start in "Full Image" view (not edit mode)
            setIsEditing(false);

            // Keep your existing crop area resets
            setCropMode(false);
            setCropArea({ x: 150, y: 150, width: 300, height: 300 });
        };
        reader.readAsDataURL(file);
    }
  };

  // const handleFileSelect = (event) => {
  //   const file = event.target.files?.[0]
  //   if (file) {
  //     console.log("docname=========",docname);
  //     if (docname === "Selfie") {
  //       const currentTime = new Date();
  //       const fileTime = new Date(file.lastModified);
  
  //       // Calculate the difference in minutes
  //       const timeDifference = (currentTime - fileTime) / 60000; // Convert ms to minutes
  
  //       if (timeDifference > 2) {
  //         setAlert({
  //           showAlert: true,
  //           severity: "error",
  //           message: "The selected image was captured more than 2 minutes ago. Please capture a new selfie.",
  //           header: "Invalid Selfie",
  //         });
  //         setShowCamera(false);

  //         if (fileInputRef.current) {
  //           fileInputRef.current.value = "";
  //         }
          
  //         return;
  //       }
  //     }

  //     const reader = new FileReader()
  //     reader.onload = (e) => {
  //       setSelectedBase64Image(e.target?.result)
  //       setPreviewDialogOpen(true)
  //       // Reset values
  //       setZoom(1)
  //       setRotation(0)
  //       setPosition({ x: 0, y: 0 })
  //       setCropMode(false)
  //       setCropArea({ x: 150, y: 150, width: 300, height: 300 })
  //     }
  //     reader.readAsDataURL(file)
  //   }
  // }

  // Handle image dragging (pan)
  // const handleMouseDown = useCallback(
  //   (e) => {
  //     if (cropMode) return // Don't allow panning in crop mode

  //     e.preventDefault()
  //     setDragging(true)

  //     const startX = e.touches ? e.touches[0].clientX : e.clientX
  //     const startY = e.touches ? e.touches[0].clientY : e.clientY
  //     const startPos = { ...position }

  //     const handleMouseMove = (moveEvent) => {
  //       const currentX = moveEvent.touches ? moveEvent.touches[0].clientX : moveEvent.clientX
  //       const currentY = moveEvent.touches ? moveEvent.touches[0].clientY : moveEvent.clientY

  //       const deltaX = currentX - startX
  //       const deltaY = currentY - startY

  //       setPosition({
  //         x: startPos.x + deltaX,
  //         y: startPos.y + deltaY,
  //       })
  //     }

  //     const handleMouseUp = () => {
  //       setDragging(false)
  //       document.removeEventListener("mousemove", handleMouseMove)
  //       document.removeEventListener("mouseup", handleMouseUp)
  //       document.removeEventListener("touchmove", handleMouseMove)
  //       document.removeEventListener("touchend", handleMouseUp)
  //     }

  //     document.addEventListener("mousemove", handleMouseMove)
  //     document.addEventListener("mouseup", handleMouseUp)
  //     document.addEventListener("touchmove", handleMouseMove)
  //     document.addEventListener("touchend", handleMouseUp)
  //   },
  //   [cropMode, position],
  // )

  const handleMouseDown = useCallback(
    (e) => {
      if (cropMode) return;
  
      e.preventDefault();
      setDragging(true);
  
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const clientY = e.touches ? e.touches[0].clientY : e.clientY;
  
      const containerRect = containerRef.current.getBoundingClientRect();
  
      dragStartRef.current = {
        x: clientX - containerRect.left - position.x,
        y: clientY - containerRect.top - position.y,
      };
    },
    [cropMode, position]
  );

  // Handle crop area dragging and resizing
  const handleCropMouseDown = useCallback(
    (e, action) => {
      if (!cropMode) return

      e.preventDefault()
      e.stopPropagation()

      const startX = e.clientX
      const startY = e.clientY
      const startCrop = { ...cropArea }

      setResizing(action)

      const handleMouseMove = (moveEvent) => {
        const deltaX = moveEvent.clientX - startX
        const deltaY = moveEvent.clientY - startY

        if (action === "move") {
          setCropArea((prev) => ({
            ...prev,
            x: Math.max(0, Math.min(600 - prev.width, startCrop.x + deltaX)),
            y: Math.max(0, Math.min(600 - prev.height, startCrop.y + deltaY)),
          }))
        } else if (action === "resize-se") {
          setCropArea((prev) => ({
            ...prev,
            width: Math.max(50, Math.min(600 - prev.x, startCrop.width + deltaX)),
            height: Math.max(50, Math.min(600 - prev.y, startCrop.height + deltaY)),
          }))
        } else if (action === "resize-nw") {
          const newWidth = Math.max(50, startCrop.width - deltaX)
          const newHeight = Math.max(50, startCrop.height - deltaY)
          const newX = Math.max(0, startCrop.x + startCrop.width - newWidth)
          const newY = Math.max(0, startCrop.y + startCrop.height - newHeight)

          setCropArea({
            x: newX,
            y: newY,
            width: newWidth,
            height: newHeight,
          })
        }
      }

      const handleMouseUp = () => {
        setResizing(null)
        document.removeEventListener("mousemove", handleMouseMove)
        document.removeEventListener("mouseup", handleMouseUp)
      }

      document.addEventListener("mousemove", handleMouseMove)
      document.addEventListener("mouseup", handleMouseUp)
    },
    [cropMode, cropArea],
  );

  // const handleTakePhoto = () => {
  //   setShowCamera(true);
  //   navigator.mediaDevices
  //       .getUserMedia({ video: true })
  //       .then((stream) => {
  //           if (videoRef.current) {
  //             console.log("stream-------",stream);
  //               videoRef.current.srcObject = stream;
  //           }
  //       })
  //       .catch((error) => {
  //           console.error("Error accessing camera:", error);
  //           setAlert({
  //               showAlert: true,
  //               severity: "error",
  //               message: "Unable to access camera. Please check permissions.",
  //               header: "Camera Error",
  //           });
  //           setShowCamera(false);
  //       });

  //   // Start Timer logic exactly as in KYCNoItem
  //   setCountdown(120);
  //   const timer = setInterval(() => {
  //       setCountdown((prev) => {
  //           if (prev <= 1) {
  //               clearInterval(timer);
  //               handleCameraClose();
  //               return 0;
  //           }
  //           return prev - 1;
  //       });
  //   }, 1000);
  //   setCameraTimeout(timer);
  // };

  // const handleImageConfirm = async () => {
  //   const img = imageRef.current
  //   const container = containerRef.current

  //   if (!img || !container) return

  //   const canvas = document.createElement("canvas")
  //   const ctx = canvas.getContext("2d")

  //   if (!ctx) return

  //   if (cropMode) {
  //     // Set canvas size to exactly match crop area dimensions
  //     canvas.width = cropArea.width
  //     canvas.height = cropArea.height

  //     const natW = img.naturalWidth
  //     const natH = img.naturalHeight
  //     const containerCenterX = 300 // container width / 2
  //     const containerCenterY = 300 // container height / 2

  //     // Calculate the actual image bounds after transformations
  //     const imageScale = zoom
  //     const scaledWidth = natW * imageScale
  //     const scaledHeight = natH * imageScale

  //     // Calculate where the crop area intersects with the transformed image
  //     const imageLeft = containerCenterX + position.x - scaledWidth / 2
  //     const imageTop = containerCenterY + position.y - scaledHeight / 2

  //     // Calculate source coordinates on the original image
  //     const sourceX = Math.max(0, (cropArea.x - imageLeft) / imageScale)
  //     const sourceY = Math.max(0, (cropArea.y - imageTop) / imageScale)
  //     const sourceWidth = Math.min(natW - sourceX, cropArea.width / imageScale)
  //     const sourceHeight = Math.min(natH - sourceY, cropArea.height / imageScale)

  //     // Apply rotation if needed
  //     if (rotation !== 0) {
  //       ctx.save()
  //       ctx.translate(cropArea.width / 2, cropArea.height / 2)
  //       ctx.rotate((rotation * Math.PI) / 180)
  //       ctx.drawImage(
  //         img,
  //         sourceX,
  //         sourceY,
  //         sourceWidth,
  //         sourceHeight,
  //         -cropArea.width / 2,
  //         -cropArea.height / 2,
  //         cropArea.width,
  //         cropArea.height,
  //       )
  //       ctx.restore()
  //     } else {
  //       // Draw only the cropped portion
  //       ctx.drawImage(img, sourceX, sourceY, sourceWidth, sourceHeight, 0, 0, cropArea.width, cropArea.height)
  //     }
  //   } else {
  //     // Original functionality for full image
  //     const canvasSize = 600
  //     canvas.width = canvasSize
  //     canvas.height = canvasSize

  //     const natW = img.naturalWidth
  //     const natH = img.naturalHeight
  //     const scale = zoom
  //     const offsetX = position.x
  //     const offsetY = position.y

  //     ctx.save()
  //     ctx.translate(canvasSize / 2 + offsetX, canvasSize / 2 + offsetY)
  //     ctx.rotate((rotation * Math.PI) / 180)
  //     ctx.scale(scale, scale)
  //     ctx.drawImage(img, -natW / 2, -natH / 2)
  //     ctx.restore()
  //   }

  //   const transformedBase64 = canvas.toDataURL("image/png")
  //   setSelectedBase64Image(transformedBase64)
  //   setPreviewDialogOpen(false)

  //   // Your existing upload logic here
  //   console.log("Processed image==============");

  //   setSelectedBase64Image(transformedBase64);
  //   setPreviewDialogOpen(false);
  //   handleCameraClose();

  //   if (pin && pinConfiguration === "once") {
  //     uploadPhoto(pin);
  //   }
  //   else if (pinConfiguration === "never") {
  //     console.log("we are at never")
  //     uploadPhoto("0000");
  //   }
  //   else {
  //     setShowPinPad(true);
  //   }
  // }

  const handleImageConfirm = async () => {
    const img = imageRef.current;
    const container = containerRef.current;

    // if (!img || !container) return;

    if (
      !img ||
      !container ||
      !img.complete ||
      img.naturalWidth === 0 ||
      img.naturalHeight === 0
    ) {
      setAlert({
        showAlert: true,
        severity: "error",
        header: "Invalid Image",
        message: "The selected file could not be loaded as an image.",
      });
      setPreviewDialogOpen(false);
      return;
    }

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    if (!ctx) return;

    // Use the logic that matches your PreviewDialog dimensions
    // Since KYCInformation usually deals with ID cards/Docs, we use the cropMode logic
    if (cropMode) {
      canvas.width = cropArea.width;
      canvas.height = cropArea.height;

      const natW = img.naturalWidth;
      const natH = img.naturalHeight;
      const containerCenterX = 300; // matching your container width / 2
      const containerCenterY = 300; // matching your container height / 2

      const imageScale = zoom;
      const scaledWidth = natW * imageScale;
      const scaledHeight = natH * imageScale;

      const imageLeft = containerCenterX + position.x - scaledWidth / 2;
      const imageTop = containerCenterY + position.y - scaledHeight / 2;

      const sourceX = Math.max(0, (cropArea.x - imageLeft) / imageScale);
      const sourceY = Math.max(0, (cropArea.y - imageTop) / imageScale);
      const sourceWidth = Math.min(natW - sourceX, cropArea.width / imageScale);
      const sourceHeight = Math.min(natH - sourceY, cropArea.height / imageScale);

      ctx.save();
      // Apply rotation if needed
      if (rotation !== 0) {
        ctx.translate(cropArea.width / 2, cropArea.height / 2);
        ctx.rotate((rotation * Math.PI) / 180);
        ctx.drawImage(
          img,
          sourceX,
          sourceY,
          sourceWidth,
          sourceHeight,
          -cropArea.width / 2,
          -cropArea.height / 2,
          cropArea.width,
          cropArea.height,
        );
      } else {
        ctx.drawImage(img, sourceX, sourceY, sourceWidth, sourceHeight, 0, 0, cropArea.width, cropArea.height);
      }
      ctx.restore();
    } else {
      // Fallback: Full image scale logic
      const canvasSize = 600;
      canvas.width = canvasSize;
      canvas.height = canvasSize;

      ctx.save();
      ctx.translate(canvasSize / 2 + position.x, canvasSize / 2 + position.y);
      ctx.rotate((rotation * Math.PI) / 180);
      ctx.scale(zoom, zoom);
      ctx.drawImage(img, -img.naturalWidth / 2, -img.naturalHeight / 2);
      ctx.restore();
    }

    const transformedBase64 = canvas.toDataURL("image/png");
    
    // --- KYCInformation Specific Logic ---
    
    // 1. Update the local preview state
    setSelectedBase64Image(transformedBase64); 
    setPreviewDialogOpen(false);

    // 2. Trigger the PinPad or Upload logic
    // In KYCInformation, we usually check if a PIN is required before calling updateKYCInfo
    if (pin && pinConfiguration === "once") {
      uploadPhoto(pin);
    }
    else if (pinConfiguration === "never") {
      console.log("we are at never")
      uploadPhoto("0000");
    }
    else {
      setShowPinPad(true);
    }
    
    // Reset camera states
    if (typeof handleCameraClose === 'function') {
        handleCameraClose();
    }
};

  // const handleImageConfirm = async() => {
  //   const img = imageRef.current;
  //   const container = containerRef.current;

  //   if (!img || !container) return;

  //   const canvasSize = 600; 
  //   const canvas = document.createElement("canvas");
  //   const ctx = canvas.getContext("2d");

  //   canvas.width = canvasSize;
  //   canvas.height = canvasSize;
  //   const natW = img.naturalWidth;
  //   const natH = img.naturalHeight;

  //   const scale = zoom;

  //   const offsetX = position.x;
  //   const offsetY = position.y;

  //   ctx.save();
  //   ctx.translate(canvasSize / 2 + offsetX, canvasSize / 2 + offsetY);
  //   ctx.rotate((rotation * Math.PI) / 180);
  //   ctx.scale(scale, scale);
  //   ctx.drawImage(img, -natW / 2, -natH / 2);
  //   ctx.restore();

  //   const transformedBase64 = canvas.toDataURL("image/png");
  //   setSelectedBase64Image(transformedBase64);
  //   setPreviewDialogOpen(false);

  //   if (pin && pinConfiguration === "once") {
  //     uploadPhoto(pin);
  //   }
  //   else if (pinConfiguration === "never") {
  //     console.log("we are at never")
  //     uploadPhoto("0000");
  //   }
  //   else {
  //     setShowPinPad(true);
  //   }
  // }

  const handleConfirm = (event, pin) => {
    let PIN = pin.join('');
    uploadPhoto(PIN);
    setShowPinPad(false);
  };

  const uploadPhoto = async(PIN) => {
    setLoading(true);
    if (!selectedBase64Image) {
      setLoading(false);
      return;
    };

    extractedData.docname = selectedKYCType?.value;

    let response

    if (extractedData.docname === "Selfie") {
      selfieChange(selectedBase64Image, extractedData.docname, docname, idNum, PIN, agent['User'].id);
    }

    else {
      let updatedDatatype = null;

      switch (extractedData.shortcode) {
        case "Passport":
          updatedDatatype = 2;
          break;
        case "Secondary Ident":
          updatedDatatype = 1;
          break;
        case "Other Identity":
          updatedDatatype = 3;
          break;
          case "Selfie":
            updatedDatatype = 4;
            break;
        default:
          updatedDatatype = extractedData.datatype; // keep existing if no match
      }

      const updatedData = {
        ...extractedData,
        datatype: updatedDatatype,
        kycType: selectedKYCType?.key
      };

      setExtractedData(updatedData); 

      console.log("selectedkyctype---------------",selectedKYCType);
      console.log("updateKYCInfo---------------",updatedData);
      console.log("extractedData---------------",extractedData);
      console.log("dataToSend-------------",selectedUser,
        updatedData,
        selectedBase64Image,
        'jpg',
        agent['User'].id,
        PIN
      );
      response = await updateKYCInfo(
        selectedUser,
        updatedData,
        selectedBase64Image,
        'jpg',
        agent['User'].id,
        PIN,
      );

    if (response?.payload?.header?.callStatus === '1' || response?.callStatus === '1') {
      console.log("updateKyc---------------",response);

      setKycAlert({
        header: 'Success',
        showAlert: true,
        message: "KYC updated",
        severity: 'success'
      });

      if (pinConfiguration === "once") {
        sessionStorage.setItem("pin", pin);
      }

      setIsEyeSlash({
        passport: false,
        address: false,
        document3: false,
        selfie: false,
      });
      setdoc1Visible(false)
      setdoc2Visible(false)
      setInfoVisible(false)
      setpassportVisible(false)
  
      setDisplayData({ ...extractedData })
      console.log("docname-----------",docname);
  
      if (extractedData.shortcode == "Passport") {
        await handleUpdate("other1", getStatus(status));
      }
      else if (extractedData.shortcode == "Secondary Ident") {
        await handleUpdate("other2", getStatus(status));
      }
      else if (extractedData.shortcode == "Other Identity") {
        await handleUpdate("other3", getStatus(status));
      }
      else {
        await handleUpdate("other5", getStatus(status));
      }

      // if (docname === "identification" || docname === "passport") {
      //   await handleUpdate("other1", getStatus(status));
      // }
      // else if (docname === "address") {
      //   await handleUpdate("other2", getStatus(status));
      // }
      // else {
      //   await handleUpdate("other5", getStatus(status));
      // }
      
    }
    else {
      setKycAlert({
        header: 'Error',
        showAlert: true,
        message: "KYC failed to update: " + response?.payload?.msg,
        severity: 'error'
      });

      setSelectedBase64Image(selectedImage);
      setLoading(false);
      return
    }
  }
    await handleSelectedUser(selectedUser);
  }

  const openFileSelectionDialog = () => {
    if (!isEditing) {
      setIsEditing(docType);
      return;
    }
    fileInputRef.current.click();
  };

  const extractFieldsFromString = (dataString) => {
    let headers
    console.log(docname)
    if (docname === "identification" || docname === "Passport") {
      headers = [
        "userid", 
        "datatype", 
        "docno", 
        "docname", 
        "docid", 
        "birthdate", 
        "expirydate", 
        "country", 
        "mdtype", 
        "issuedate",
        "stateid"
      ];
    }
    else {
      headers = [
        "userid", 
        "datatype", 
        "docno", 
        "docname", 
        "docid", 
        // "birthdate",  
        "expirydate", 
        "country", 
        "mdtype", 
        "issuedate",
        "stateid"
      ];
    }
      
    
    const values = dataString.split("|"); 

    console.log(values)
    console.log(dataString)

    const extractedObject = headers.reduce((obj, header, index) => {
      obj[header] = values[index] || null;
      return obj;
    }, {});

    return extractedObject;
  };

  useEffect(() => {
    let data = kycData?.sensitiveData
    console.log(data)
    if (data) {
      const extractedFields = extractFieldsFromString(data);
      setExtractedData({...extractedFields, dataid: kycData?.dataid, datatype: kycData?.datatype, shortcode: kycData?.shortcode}); // Store the extracted data
      setDisplayData({...extractedFields, dataid: kycData?.dataid, datatype: kycData?.datatype, shortcode: kycData?.shortcode}); // Store the extracted data
    }
  }, [kycData])

  const getNotesList = async () => {
    let response = await getNotes(selectedUser);

    if(response?.callStatus == "1") {
      // let rejNoteList = response.payload.record;
      const rejNoteList = Array.isArray(response?.payload?.record) ? response?.payload?.record : [response?.payload?.record];
      let rejectionNote = null;
      console.log("rejNoteList------------",rejNoteList);
      if(rejNoteList?.length > 0 && rejNoteList[0] !== undefined) {
        for (let i = rejNoteList?.length - 1; i >= 0; i--) {
          let currentNote = rejNoteList[i]?.Usernotes.notes;
          let [dataId, noteContent] = currentNote.split('|').map(part => part.trim());
          if (dataId === kycData?.dataid) {
            rejectionNote = noteContent; 
            break;  
          }
        }
        setRejectionNote(rejectionNote);

      }
    }
  
    // let rejNoteList = response.payload.record;
    // let rejectionNote = null;
  
    // for (let i = rejNoteList?.length - 1; i >= 0; i--) {
    //   let currentNote = rejNoteList[i].Usernotes.notes;
    //   let [dataId, noteContent] = currentNote.split('|').map(part => part.trim());
    //   if (dataId === kycData?.dataid) {
    //     rejectionNote = noteContent; 
    //     break;  
    //   }
    // }
  
    // setRejectionNote(rejectionNote);
  
    // console.log('Rejection Note:', rejectionNote);
  };
  

  useEffect(() => {
    getNotesList();
  }, [])

  const openCamera = () => {
    if (cameraTimeout) clearInterval(cameraTimeout);

    setShowCamera(true);
    const constraints = { 
      video: { facingMode: facingMode } 
    };

    navigator.mediaDevices
      .getUserMedia(constraints)
      // .getUserMedia({ video: true })
      .then((stream) => {
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          videoRef.current.play();
        }
        // videoRef.current.srcObject = stream;
        // videoRef.current.play();
      })
      .catch((error) => {
        console.error("Error accessing camera:", error);
        setAlert({
          showAlert: true,
          severity: "error",
          message: "Unable to access camera. Please check permissions.",
          header: "Camera Error",
        });
      });

      setCountdown(120);

  const timer = setInterval(() => {
    setCountdown((prev) => {
      if (prev <= 1) {
        clearInterval(timer);
        handleCameraClose();
        setAlert({
          showAlert: true,
          severity: "warning",
          message: "Camera timeout. Please try again.",
          header: "Timeout",
        });
        return 0;
      }
      return prev - 1;
    });
  }, 1000);

    setCameraTimeout(timer);
  };

  const toggleCamera = () => {
    // 1. Switch the state
    const newMode = facingMode === "user" ? "environment" : "user";
    setFacingMode(newMode);

    if (cameraTimeout) {
      clearInterval(cameraTimeout);
      setCameraTimeout(null);
    }

    // 2. Stop the current camera stream
    if (videoRef.current && videoRef.current.srcObject) {
        const tracks = videoRef.current.srcObject.getTracks();
        tracks.forEach(track => track.stop());
    }

    // 3. Restart camera with new mode
    // We use a slight timeout or call openCamera directly if it's already using the updated facingMode state
    setTimeout(() => {
        openCamera();
    }, 100);
  };

  // const handleCapture = () => {
  //   const canvas = canvasRef.current;
  //   const video = videoRef.current;
  //   const context = canvas.getContext("2d");

  //   canvas.width = video.videoWidth;
  //   canvas.height = video.videoHeight;
  //   context.drawImage(video, 0, 0, canvas.width, canvas.height);

  //   const imageData = canvas.toDataURL("image/png");
  //   // console.log(imageData);
  //   setSelectedBase64Image(imageData);

  //   handleCameraClose();
  //   setShowPinPad(true);
  // };

  const handleCapture = () => {
    const canvas = canvasRef.current;
    const video = videoRef.current;
    const context = canvas.getContext("2d");

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    const imageData = canvas.toDataURL("image/png");
    
    setTempOriginalImage(imageData);
    setSelectedBase64Image(imageData);
    handleCameraClose();
    setIsEditing(false); 
    setPreviewDialogOpen(true); 
  };

  const handleCameraClose = () => {
    if (cameraTimeout) {
      clearTimeout(cameraTimeout);
    }
    setShowCamera(false);
    if (videoRef.current && videoRef.current.srcObject) {
      let stream = videoRef.current.srcObject;
      let tracks = stream.getTracks();

      tracks.forEach((track) => track.stop());
      videoRef.current.srcObject = null;
    }
  };

  if (isReject) {
    return (
      <Box className="information-container">
        <Box className="image-container">
          <Box className="document-details">

            <Box className="document-line">
              <Box className="notes-block">
                <Typography variant="h9" className="document-fields">Notes:</Typography>
                <Typography variant="h9" className="document-fields-small">
                  (Mandatory if Rejecting Document)
                </Typography>
              </Box>
              <Box className="comment-block">
                {(status !== "Rejected") ?
                <>
                <textarea 
                  placeholder="Type Comment..." 
                  className="notes-input"  
                  value={comment} 
                  onChange={(e) => setComment(e.target.value)} 
                />
                <button className="submit-arrow" onClick={() => {onReject(comment); handleIsReject()}}>
                  <img src={RightArrow} alt="submit" loading="lazy" />
                </button>
                </>
                :
                <>
                <Box sx={{marginLeft: "10px"}}>
                  <Typography variant="h10" className="document-fields">{rejectionNote}</Typography>
                </Box>
                </>
                }
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    );
  }

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    if (!isClicked) {
      setIsHovered(false);
    }
  };

  const handleClickImage = () => {
    setIsClicked(true);
    setIsHovered(false)
  };

  const handleClose = () => {
    setIsClicked(false);
    setIsHovered(false);
  };

  const validateFields = () => {
    let newErrors = {};
  
    if (!extractedData?.docid) {
      newErrors.docid = "Document Number is required";
    }
    if (!extractedData?.issuedate) {
      newErrors.issuedate = "Issue Date is required";
    }
    if (!extractedData?.expirydate) {
      newErrors.expirydate = "Expiry Date is required";
    }
    if (!extractedData?.country) {
      newErrors.country = "Country is required";
    }
    if (!extractedData?.stateid) {
      newErrors.stateid = "State is required";
    }
  
    setErrors(newErrors);
    setHasSubmitted(true);

    console.log(newErrors)
  
    if (Object.keys(newErrors).length > 0) {
      return false;
    }
    return true;
  };

  return (
    <>
    <Box className="information-container">
      <Box className="image-container">

        <Box
          className="image-box"
          sx={{
            position: "relative",
            cursor: "pointer",
            borderRadius: "8px",
            overflow: "hidden",
            backdropFilter: isClicked ? "blur(5px)" : "none", 
          }}
        >
          <div className="scrollable-container">
            <Box
              className="image-box"
              onClick={handleClickImage}
              sx={{
                position: "relative",
                cursor: "pointer",
                maxHeight: '200px',
                borderRadius: "8px",
                overflow: "hidden",
                backdropFilter: isClicked ? "blur(5px)" : "none", 
              }}
            >
              <img
                src={selectedBase64Image || selectedImage || EmptyPhoto}
                alt="Preview"
                style={{
                  width: "100%",
                  objectFit: "contain",
                  opacity: isHovered || isClicked ? 0.8 : 1, 
                  transition: "opacity 0.3s ease", 
                  maxHeight: '200px',
                }}
                onMouseEnter={showPinPad ? null : handleMouseEnter}
                onMouseLeave={showPinPad ? null : handleMouseLeave}
                loading="lazy"
              />
            </Box>
            <input type="file" accept="image/*" onChange={handleFileSelect} style={{ display: "none" }} ref={fileInputRef} />
            <Button 
              sx={{ 
                textTransform: "capitalize",
                width: "160px",
                height: "37px",
                flexShrink: 0,
                borderRadius: "5px",
                background: "#FFF",
                color: "#008ECC",
                fontFamily: "Nunito",
                fontSize: "15px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "33.6px",
                border: "1px solid #008ECC",
                position: "relative",
                marginTop: "10px",
                "&:hover": {
                  background: "#B3E3F2"
                }
              }}
              onClick={doctype !== "Selfie" && doctype !== "selfie" ? openFileSelectionDialog : openCamera}>
                {!isEditing && doctype !== "Selfie" && doctype !== "selfie" ? "Edit" : "Change Document"}
            </Button>

            {isEditing && doctype !== "Selfie" && doctype !== "selfie" && <Button
              sx={{
                textTransform: "capitalize",
                minWidth: "160px",
                height: "37px",
                borderRadius: "5px",
                background: "#008ECC",
                color: "#FFF",
                fontFamily: "Nunito",
                fontSize: "14px",
                fontWeight: 700,
                marginTop:'5px',
                "&:hover": { background: "#007bb2" }
              }}
              onClick={openCamera} // Call the camera function
            >
              <img src={captureImage} alt="" style={{ marginRight: '8px', width: '16px', filter: 'brightness(0) invert(1)', padding:'2px', width:'15%' }} />
              Take Photo
            </Button>}
          </div>        
        </Box>

        {(isHovered || isClicked) && (
          <>
          <Box
          className="backdrop"
          sx={{
            display: isClicked ? "block" : "none", 
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)", 
            transition: "opacity 0.3s ease, backdrop-filter 0.3s ease", 
            zIndex: 1200, 
          }}
          onClick={handleClose} 
        />

        <Box
          className="custom-modal"
          onMouseEnter={handleMouseEnter} 
          onMouseLeave={handleMouseLeave} 
          onClick={handleClickImage}
          sx={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "700px",
            height: isClicked ? "550px" : "450px",
            backgroundColor: "#fff",
            borderRadius: "8px",
            zIndex: 1300, 
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
            boxShadow: isClicked ? "0 4px 8px rgba(0, 0, 0, 0.2)" : "none",
          }}
        >
          <img
            src={selectedBase64Image || selectedImage}
            alt="Preview"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
            loading="lazy"
          />
          {(isClicked || isHovered ) && <IconButton
            onClick={(e) => {
              e.stopPropagation(); 
              handleClose(); 
            }}
            sx={{
              position: "absolute",
              top: "10px",
              right: "10px",
              color: "#000",
            }}
          >
            <CloseIcon />
          </IconButton>}
        </Box>
        </>
  )}
        
        <Box className="document-details">
          
          {/* DOC TYPE */}
          <Box className="document-line">
            <Typography variant="h9" className="document-fields">Document Type:</Typography>
            <Typography variant="h9" className="document-data">
              {displayData?.docname}
            </Typography>
          </Box>

          {/* DOC NO */}
          {(doctype !== "Selfie") && 
          <>
            <Box className="document-line">
              <Typography variant="h9" className="document-fields">Document Number:</Typography>
              <Typography variant="h9" className="document-data">{displayData?.docid}</Typography>
            </Box>

          <Box className="document-line">
            <Typography variant="h9" className="document-fields">Document Expiry Date:</Typography>
            <Typography variant="h9" className="document-data">
              {displayData?.expirydate}
            </Typography>
          </Box>

          <Box className="document-line">
            <Typography variant="h9" className="document-fields">Document Issue Date:</Typography>
            <Typography variant="h9" className="document-data">
              {displayData?.issuedate}
            </Typography>
          </Box>

          <Box className="document-line">
            <Typography variant="h9" className="document-fields">Date of Birth:</Typography>
            <Typography variant="h9" className="document-data">
              {user['User'].dateofbirth}
            </Typography>
          </Box>

          {/* COUNTRY */}
          <Box className="document-line">
            <Typography variant="h9" className="document-fields">Country:</Typography>
            <Typography variant="h9" className="document-data">
              {displayData?.country}
            </Typography>
          </Box>

          {/* State */}
          <Box className="document-line">
            <Typography variant="h9" className="document-fields">State:</Typography>
            <Typography variant="h9" className="document-data">
            {
              (
                displayData?.country === "" || displayData?.country === "na")
                ? 
                [{ key: "not-available", value: "not-available", label: "Not Available" }]
                : 
                displayStateOptions?.find(state => state.value === displayData?.stateid)?.label
              }
            </Typography>
          </Box>
        </>
          }

          {status === "Rejected" && <Box className="document-line">
            <Typography variant="h9" className="document-fields">Reject Reason:</Typography>
            <Typography variant="h9" className="document-data">
              {rejectionNote}
            </Typography>
          </Box>}
        </Box>
      </Box>
      {docname !== "Selfie" && isEditing &&
      <Box 
        className="identifcation-details"
      >

          {
            <Autocomplete
              key={docname}
              value={selectedKYCType || null}
              onChange={(e, newValue) => {
                setSelectedKYCType(newValue);
              }}
              disabled={docType === "selfie" || docType === "passport"}
              options={kycTypes}
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(option, value) => option.value === value}
              sx={{ 
                width: "25%", 
                marginTop: "15px",
                marginBottom: "10px",
                height: "40px",
                ".MuiSelect-select": {
                  padding: "4px 6px",
                },
              }} 
              renderInput={(params) => (
                <TextField
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                    sx: {
                      padding: "0",   
                      alignItems: "center", 
                    },
                  }}
                  error={!!errors.docname}
                  sx={{
                    width: "215px", 
                    alignItems: "center", 
                    "& .MuiOutlinedInput-root": {
                      height: "40px", 
                      alignItems: "center", 
                    },
                    "& .MuiAutocomplete-endAdornment": {
                      top: "50%",
                      right: "8px", 
                    },
                  }}
                />
              )}
            />
          }

            <Autocomplete
              value={
                extractedData?.country 
                ? 
                getOptionsForSelect("country").find(country => country.value === extractedData.country)
                : 
                getOptionsForSelect("country")[0]
              }
              error={!!errors.country}
              onChange={(e, newValue) => setExtractedData({...extractedData, country: newValue ? newValue?.value : ""})}
              options={getOptionsForSelect("country")}
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(option, value) => option.value === value}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Country"
                  InputProps={{
                    ...params.InputProps,
                    sx: {
                      height: "40px", 
                      padding: "0",   
                    },
                  }}
                  error={!!errors.country}
                  inputRef={(e) => (firstErrorRef.current = { ...firstErrorRef.current, country: e })}
                  sx={{
                    width: "215px", 
                    marginTop: "15px",
                    marginBottom: "10px",
                    "& .MuiOutlinedInput-root": {
                      height: "40px", 
                      padding: "0 8px",
                    },
                    "& .MuiInputLabel-root": {
                      top: "-7px", 
                    },
                  }}
                />
              )}
            />

            <Autocomplete
              value={
               (extractedData?.country === "" || extractedData?.country === "na")
                  ? [{ key: "not-available", value: "not-available", label: "Not Available" }]
                  : stateOptions?.find(state => state.value === extractedData?.stateid)
              }
              onChange={(e, newValue) => setExtractedData({...extractedData, stateid: newValue.value})}
              options={stateOptions}
              getOptionLabel={(option) => option.label || ""}
              isOptionEqualToValue={(option, value) => option.value === value}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select State"
                  variant="outlined"
                  inputRef={(e) => (firstErrorRef.current = { ...firstErrorRef.current, stateid: e })}
                  InputProps={{
                    ...params.InputProps,
                    sx: {
                      height: "40px",
                      padding: "0",  
                    },
                  }}
                  error={!!errors.stateid}
                  sx={{
                    width: "215px", 
                    marginTop: "15px",
                    marginBottom: "10px",
                    "& .MuiOutlinedInput-root": {
                      height: "40px", 
                      padding: "0 8px", 
                    },
                    "& .MuiInputLabel-root": {
                      top: "-7px", 
                    },
                  }}
                />
              )}
            />

            <TextField
              label="Document Number"
              fullWidth
              margin="normal"
              value={extractedData?.docid}
              error={!!errors.docid}
              onChange={(e) => setExtractedData({...extractedData, docid: e.target.value})}
              inputRef={(e) => (firstErrorRef.current = { ...firstErrorRef.current, docid: e })}
              sx={{
                width: '25%', 
                marginTop: 2,
                marginBottom: 2,
                '& input': {
                  padding: '8px 12px', 
                },
              }}
            />

          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              inputFormat="yyyy/MM/dd"
              fullWidth
              margin="normal"
              value={parseISO(user['User'].dateofbirth)}
              label="Date of Birth"
              InputLabelProps={{ 
                shrink: true,
                style: {
                  fontSize: '12px',
                  color: "inherit !important"
                }
              }}
              disabled
              sx={{
                width: '25%', 
                marginTop: 2,
                marginBottom: 2,
                '& input': {
                  padding: '8px 12px',
                  color: "inherit !important"
                },
              }}
            />
          </LocalizationProvider>

          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              inputFormat="yyyy/MM/dd"
              fullWidth
              margin="normal"
              value={parseISO(extractedData?.issuedate)}
              slotProps={{ 
                textField: { 
                  inputRef: (e) => (firstErrorRef.current = { ...firstErrorRef.current, issuedate: e }),
                  sx: {
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor:
                        hasSubmitted && errors.issuedate
                          ? "red !important"
                          : "#d1d5db !important",
                    },
                    '& .MuiFormLabel-root': {
                      color: hasSubmitted && !!errors.issuedate ? 'red' : 'inherit', 
                    },
                    width: '25%', 
                    marginTop: 2,
                    marginBottom: 2,
                    '& input': {
                      padding: '8px 12px', 
                    },
                  },
                } }}
              label="Document Issue Date"
              InputLabelProps={{ 
                shrink: true,
                style: {
                  color: hasSubmitted && errors.issuedate ? "red !important" : "inherit !important",
                }
              }}
              onChange={(newDate) => {
                if (newDate && !isNaN(newDate)) {
                  setExtractedData({...extractedData, issuedate: format(newDate, "yyyy-MM-dd")})
                }
              }}
              sx={{
                width: '25%', 
                marginTop: 2,
                marginBottom: 2,
                '& input': {
                  padding: '8px 12px', 
                },
              }}
            />
          </LocalizationProvider>

          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              inputFormat="yyyy/MM/dd"
              fullWidth
              margin="normal"
              value={parseISO(extractedData?.expirydate)}
              slotProps={{ 
                textField: { 
                  inputRef: (e) => (firstErrorRef.current = { ...firstErrorRef.current, expirydate: e }),
                  sx: {
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor:
                        hasSubmitted && errors.expirydate
                          ? "red !important"
                          : "#d1d5db !important",
                    },
                    '& .MuiFormLabel-root': {
                      color: hasSubmitted && !!errors.expirydate ? 'red' : 'inherit', 
                    },
                    width: '25%', 
                    marginTop: 2,
                    marginBottom: 2,
                    '& input': {
                      padding: '8px 12px', 
                    },
                  },
                } }}
              label="Document Expiry Date"
              InputLabelProps={{ 
                shrink: true,
                style: {
                  color: hasSubmitted && errors.issuedate ? "red !important" : "inherit !important",
                }
              }}
              onChange={(newDate) => {
                if (newDate && !isNaN(newDate)) {
                  setExtractedData({...extractedData, expirydate: format(newDate, "yyyy-MM-dd")})
                }
            }}
              sx={{
                width: '25%',
                marginTop: 2,
                marginBottom: 2,
                '& input': {
                  padding: '8px 12px', 
                },
              }}
            />
          </LocalizationProvider>

      </Box>
      }
          {isEditing && doctype !== "Selfie" && doctype !== "selfie" &&
            <Button 
              onClick={() => {
              if (!validateFields()) return;
                pin ? uploadPhoto(pin) : pinConfiguration === "never" ? uploadPhoto("0000") : setShowPinPad(true)}}
              sx={{
                textTransform: "capitalize",
                width: "150px",
                height: "37px",
                flexShrink: 0,
                borderRadius: "5px",
                background: "#008ECC",
                color: "#FFF",
                fontFamily: "Nunito",
                fontSize: "15px",
                fontStyle: "normal",
                fontWeight: 700,
                border: "none",
                position: "relative",
                marginTop: "5px",
                "&:hover": {
                  background: "#40A6D4" 
                }
              }}
            >
              {selectedBase64Image && "Update KYC Info"}
            </Button>
          }
    </Box>
    {showPinPad && 
      <PinPad 
        show={showPinPad} 
        handleConfirm={handleConfirm} 
        onClick={() => setShowPinPad(false)} 
      />
    }

    <Dialog open={showCamera} onClose={handleCameraClose} fullWidth maxWidth="sm">
          <DialogContent>
            <video ref={videoRef} style={{ width: "100%", height: "auto" }} />
            <canvas ref={canvasRef} style={{ display: "none" }} />
            <Typography
            variant="h6"
            sx={{
              fontStyle: "normal",
              fontWeight: 400,
              fontSize: "20px",
              lineHeight: "25px",
              textAlign: "center",
              marginTop: 2,
              color: "#DC3545", 
              fontFamily: "Nunito",
            }}
          >
            Time Remaining: {Math.floor(countdown / 60)}:{String(countdown % 60).padStart(2, "0")}
          </Typography>
          </DialogContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Divider sx={{ my: 2, border: "1px solid #A6A6A6", width: "70%" }} />
          </Box>
          <DialogActions
            sx={{
              display: "flex",
              justifyContent: "center", 
              alignItems: "center", 
              gap: 3, 
              flexDirection: "space-between",
              marginBottom: "30px"
            }}
          >
              <Button
                variant="contained"
                onClick={handleCapture}
                startIcon={<img src={captureImage} alt="Capture Icon" style={{ width: "20px", height: "20px" }} loading="lazy" />}
                sx={{
                  backgroundColor: "#007BFF", 
                  color: "#FFF", 
                  padding: "10px 20px", 
                  borderRadius: "8px", 
                  textTransform: "none", 
                  fontSize: "16px", 
                  fontWeight: 600,
                  fontFamily: "Nunito",
                  "&:hover": {
                    backgroundColor: "#0056b3", 
                  },
                }}
              >
                {(docname == "Selfie" || docname == "selfie") ? `Take Selfie Now` : 'Take Photo Now'}
              </Button>

              <Button
                variant="outlined"
                onClick={toggleCamera}
                sx={{
                  color: "#007BFF",
                  borderColor: "#007BFF",
                  padding: "10px 20px",
                  borderRadius: "8px",
                  textTransform: "none",
                  fontFamily: "Nunito",
                  fontWeight: 600,
                }}
              >
                Switch Camera
              </Button>

              {(docname == "Selfie" || docname == "selfie") &&
                <Button
                  variant="contained"
                  onClick={openFileSelectionDialog}
                  startIcon={<img src={uploadImage} alt="Upload Icon" style={{ width: "20px", height: "20px" }} loading="lazy" />}
                  sx={{
                    backgroundColor: "#003366", 
                    color: "#FFF", 
                    padding: "10px 20px", 
                    borderRadius: "8px", 
                    textTransform: "none", 
                    fontSize: "16px", 
                    fontWeight: 600,
                    fontFamily: "Nunito",
                    "&:hover": {
                      backgroundColor: "#002244", 
                    },
                  }}
                >
                  Upload Selfie
                </Button>
              }
          </DialogActions>
    </Dialog>

    <Dialog open={previewDialogOpen} onClose={() => setPreviewDialogOpen(false)} maxWidth="md" fullWidth>
        <DialogContent sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          {/* Crop Mode Toggle */}
          {/* <Box sx={{ mb: 2 }}>
            <Chip
              icon={<Crop />}
              label={cropMode ? "Exit Crop Mode" : "Crop Mode"}
              onClick={() => setCropMode(!cropMode)}
              color={cropMode ? "primary" : "default"}
              variant={cropMode ? "filled" : "outlined"}
            />
          </Box> */}

          {/* Image Container */}
          <Box
            ref={containerRef}
            sx={{
              width: 600,
              height: 600,
              border: "2px solid #d3d3d3",
              borderRadius: "12px",
              backgroundColor: "#fefefe",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
              position: "relative",
              cursor: cropMode ? "crosshair" : dragging ? "grabbing" : "grab",
            }}
          >
            {selectedBase64Image && (
              <>
                <Box
                  component="img"
                  src={selectedBase64Image}
                  alt="Preview"
                  ref={imageRef}
                  onMouseDown={handleMouseDown}
                  onTouchStart={handleMouseDown}
                  draggable={false}
                  sx={{
                    cursor: cropMode ? "crosshair" : dragging ? "grabbing" : "grab",
                    transform: `translate(${position.x}px, ${position.y}px) scale(${zoom}) rotate(${rotation}deg)`,
                    transition: dragging || resizing ? "none" : "transform 0.3s ease-in-out",
                    userSelect: "none",
                    position: "absolute",
                  }}
                />

                {/* Crop Overlay */}
                {cropMode && (
                  <>
                    {/* Dark overlay */}
                    <Box
                      sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        pointerEvents: "none",
                      }}
                    />

                    {/* Crop area */}
                    <Box
                      sx={{
                        position: "absolute",
                        left: cropArea.x,
                        top: cropArea.y,
                        width: cropArea.width,
                        height: cropArea.height,
                        border: "2px solid white",
                        cursor: "move",
                        "&::before": {
                          content: '""',
                          position: "absolute",
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          border: "1px dashed rgba(255, 255, 255, 0.5)",
                        },
                      }}
                      onMouseDown={(e) => handleCropMouseDown(e, "move")}
                    >
                      {/* Resize handles */}
                      <Box
                        sx={{
                          position: "absolute",
                          top: -4,
                          left: -4,
                          width: 8,
                          height: 8,
                          backgroundColor: "white",
                          border: "1px solid #666",
                          cursor: "nw-resize",
                        }}
                        onMouseDown={(e) => handleCropMouseDown(e, "resize-nw")}
                      />
                      <Box
                        sx={{
                          position: "absolute",
                          bottom: -4,
                          right: -4,
                          width: 8,
                          height: 8,
                          backgroundColor: "white",
                          border: "1px solid #666",
                          cursor: "se-resize",
                        }}
                        onMouseDown={(e) => handleCropMouseDown(e, "resize-se")}
                      />
                    </Box>
                  </>
                )}
              </>
            )}
          </Box>

          {/* Controls */}
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: 3, width: "80%" }}>
            <Typography variant="body2" gutterBottom sx={{ fontFamily: "Nunito", fontWeight: 600 }}>
              <ZoomIn sx={{ mr: 1, verticalAlign: "middle" }} />
              Zoom Level
            </Typography>
            <Slider
              value={zoom}
              min={0.2}
              max={3}
              step={0.1}
              onChange={(e, value) => setZoom(value)}
              sx={{ width: "100%" }}
              valueLabelDisplay="auto"
            />
            <Box sx={{ display: "flex", justifyContent: "center", gap: 2, marginTop: 2 }}>
              <Button variant="outlined" onClick={() => setRotation((r) => r - 90)} startIcon={<RotateLeft />}>
                Rotate Left
              </Button>
              <Button variant="outlined" onClick={() => setRotation((r) => r + 90)} startIcon={<RotateRight />}>
                Rotate Right
              </Button>
              {/* Crop Mode Toggle */}
              <Button variant="outlined" onClick={() => setCropMode(!cropMode)} startIcon={<Crop />}>
                {cropMode ? "Exit Crop Mode" : "Crop Mode"}
              </Button>
            </Box>
          </Box>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", gap: 2, paddingBottom: 2 }}>
          <Button variant="contained" color="primary" onClick={handleImageConfirm}>
            Confirm
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              setPreviewDialogOpen(false)
              setSelectedBase64Image(null)
            }}
          >
            Cancel
          </Button>
        </DialogActions>
    </Dialog>

        {/* <Dialog open={previewDialogOpen} onClose={() => setPreviewDialogOpen(false)} maxWidth="md" fullWidth>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Box
            ref={containerRef}
            sx={{
              width: 600,
              height: 600,
              border: '2px solid #d3d3d3',
              borderRadius: '12px',
              backgroundColor: '#fefefe',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              overflow: 'hidden',
              position: 'relative',
            }}
          >
            {selectedBase64Image && (
              <Box
                component="img"
                src={selectedBase64Image}
                alt="Preview"
                ref={imageRef}
                onMouseDown={handleMouseDown}
                onTouchStart={handleMouseDown}
                draggable={false}
                sx={{
                  cursor: dragging ? 'grabbing' : 'grab',
                  transform: `translate(${position.x}px, ${position.y}px) scale(${zoom}) rotate(${rotation}deg)`,
                  transition: dragging ? 'none' : 'transform 0.3s ease-in-out',
                  userSelect: 'none',
                  position: 'absolute', 
                }}
              />
            )}
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 3, width: '80%' }}>
            <Typography variant="body2" gutterBottom sx={{ fontFamily: 'Nunito', fontWeight: 600 }}>
              Zoom Level
            </Typography>
            <Slider
              value={zoom}
              min={0.5}
              max={3}
              step={0.1}
              onChange={(e, value) => setZoom(value)}
              sx={{ width: '100%' }}
              valueLabelDisplay="auto"
            />
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, marginTop: 2 }}>
              <Button variant="outlined" onClick={() => setRotation((r) => r - 90)}>Rotate Left</Button>
              <Button variant="outlined" onClick={() => setRotation((r) => r + 90)}>Rotate Right</Button>
            </Box>
          </Box>
        </DialogContent>

          <DialogActions sx={{ justifyContent: 'center', gap: 2, paddingBottom: 2 }}>
            <Button variant="contained" color="primary" onClick={() => {
              handleImageConfirm();
            }}>
              Confirm
            </Button>
            <Button variant="outlined" onClick={() => {
              setPreviewDialogOpen(false);
              setSelectedBase64Image(null);
            }}>
              Cancel
            </Button>
          </DialogActions>
        </Dialog> */}

      <CustomAlert 
        severity={alert.severity} 
        show={alert.showAlert} 
        header={alert.header} 
        message={alert.message} 
        onClick={(prevDetails) => setAlert({...prevDetails, showAlert: false})} 
        autoclose={alert.severity === "error" ? false : true} 
      />
    </>
  );
}

export default KYCInformation;
